module.exports = __webpack_public_path__ + "static/img/成果教程.bbfc449d.svg";